import React, { Component } from "react";
import Loader from "./Loader";

class AccommodationDetailsLoader extends Component {
  render() {
    return (
      <div className="row  no-gutters">
        <div className="col-lg-12">
          <div className="card  min-h-700">
            <div className="card-header">
              <div className="row no-gutters">
                <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 pt-3">
                  Hostel Details
                </div>
              </div>
            </div>
            <div className="card-body accomodation-details p-0 m-0 ">
              <div className="hostel-image-cont">
                <Loader width="835" height="150" />
              </div>
              <div className="content col">
                <div className="hostel-details row">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
                    <div className="title">
                      <Loader height="30" width="200" />
                    </div>
                    <div className="hostel-details-info">
                      <Loader height="15" width="100" />
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
                    <div className="price-details">
                      <div className="price">
                        <Loader width="320" height="100" />
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <Loader width="350" height="150" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hostel-location-overview row ">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <div className="location">
                      <Loader width="100" height="30" />
                      <div className="address-map">
                        <div className="address">
                          <span className="address-text">
                            <Loader width="150" height="30" />
                          </span>
                        </div>
                        <div className="map">
                          <Loader width="350" height="300" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                    <div className="overview">
                      <Loader width="150" height="30" />
                      <div className="overview-content">
                        <Loader width="350" height="300" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* card for accomodation details */}
            </div>
          </div>
        </div>
        {/* Book a bedspace Pop-up */}
      </div>
    );
  }
}

export default AccommodationDetailsLoader;
